import { Injectable } from '@angular/core';
import { EMPTY, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountService } from '../../account/account.service';
import { BaseService } from '../../_services/base.service';
import { SettingsService } from '../../_services/settings.service';
import { CentralSemaforoCotacao } from '../semaforo-conversor/_models/cotacao';
import { EditPartNumberPostModel } from './_models/editPartNumberPostModel';

declare const isEmpty: any;

@Injectable({ providedIn: 'root' })
export class BuyerSemaforoCuradorService extends BaseService {
    private _domain: string = '/buyer/semaforo';
    listaCotacoes: CentralSemaforoCotacao[];
    listItemHeightCentral: number = 30.8;

    constructor(private accountService: AccountService, private config: SettingsService) {
        super();
    }

    public associarPecaNF(itemId: number, orderId: number, nroNotaFiscal: string): Observable<any> {
        const url = `${this._domain}/orders/${orderId}/items/${itemId}/notas-fiscais/${nroNotaFiscal}/associar`;
        return this.config.executePost({ url, body: {} })
    }

    public editPartNumber(orderId: number, itemId: number, model: EditPartNumberPostModel): Observable<any> {
        const url = `${this._domain}/orders/${orderId}/items/${itemId}/change-part-number`;
        return this.config.executePost({ url, body: model })
    }

    public existsPossibleOrdersToMerge(orderId: number): Observable<any> {
        const url = `${this._domain}/${orderId}/merge/check-exists-orders-to-merge`;
        return this.config.executeGet({ url })
    }

    public getAddComplementData(orderId: number): Observable<any> {
        const url = `${this._domain}/orders/${orderId}/add-complement-data`;
        console.log(url)
        return this.config.executeGet({ url })
    }

    public getNotaFiscalByOrderId(orderId: number): Observable<any> {
        const url = `${this._domain}/orders/${orderId}/notas-fiscais`;
        return this.config.executeGet({ url })
    }

    public getOrdersForMerge(orderId: number): Observable<any> {
        const url = `${this._domain}/${orderId}/merge`;
        return this.config.executeGet({ url })
    }

    public listQuotations(isConversor: boolean, ignorarCache: boolean = false): Observable<any> {
        return this.config.executeGet({ url: `${this._domain}?isConversor=${isConversor}&ignoreCache=${ignorarCache}` }).pipe(
            map((response: any) => {
                this.listaCotacoes = response.cotacoes;
                return response || [];
            })
        );
    }

    public markOrderAsSolved(orderId: number, items_id: number[]): Observable<any> {
        const body = { itemsId: items_id };
        const url = `${this._domain}/${orderId}/mark-as-solved`;
        return this.config.executePost({ url, body })
    }

    public markOrderInconsistencesAsSolved(orderId: number, ids: string[], motivo: string): Observable<any> {
        const body = { ids, motivo };
        const url = `${this._domain}/${orderId}/mark-inconsistencies-as-solved`;
        return this.config.executePost({ url, body })
    }

    public mergeOrder(orderId: number, orderIdToMerge: number): Observable<any> {
        const url = `${this._domain}/${orderId}/merge/${orderIdToMerge}`;
        return this.config.executePost({ url });
    }

    public obter(quotation_id: number, ignorar_cache: boolean = false): Observable<any> {
        return this.listQuotations(ignorar_cache)
            .pipe(
                map((response: any) => {
                    this.listaCotacoes = response.result.quotations;

                    if (isEmpty(this.listaCotacoes))
                        return null;

                    return this.listaCotacoes.find(c => c.quotation_id === quotation_id);
                })
            );
    }

    public setShippingCompany(orderId: number, dadosTransportadora: any): Observable<any> {
        const body = { dadosTransportadora };
        const url = `${this._domain}/${orderId}/set-shipping-company`;
        return this.config.executePost({ url, body });
    }
}
